import Helper from '../helpers';
import config from '../config';

const baseUrl = config.apiBaseUrl;

export class ClassBookingService {
    private isPublic: boolean;
    constructor(isPublic = false) {
        this.isPublic = isPublic;
    }

    async bookSingleClass(classId) {
        const token = await Helper.getCookie('wh-jwt');

        try {
            const res = await fetch(`${baseUrl}/api/classes/signup/${classId}`, {
                method: 'POST',
                headers: {'Authorization': `Bearer ${token}`}
            });

            if (res.ok) {
                const result = await res.json();
                return { success: true, paymentUrl: result.paymentUrl };
            } else {
                const error = await res.text();
                console.error('Failed to book class:', error);
                return { success: false, error: 'Failed to book class. Please try again.' };
            }
        } catch (error) {
            console.error('Error booking class:', error);
            return { success: false, error: 'An error occurred while booking the class. Please try again.' };
        }
    }

    async bookBulkDates(classId, dates) {
        const token = await Helper.getCookie('wh-jwt');

        try {
            const res = await fetch(`${baseUrl}/api/classes/book-bulk`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    classId: parseInt(classId),
                    dates: dates
                })
            });

            if (res.ok) {
                const result = await res.json();
                return { success: true, paymentUrl: result.paymentUrl };
            } else {
                const error = await res.text();
                console.error('Failed to book classes:', error);
                return { success: false, error: 'Failed to book classes. Please try again.' };
            }
        } catch (error) {
            console.error('Error booking classes:', error);
            return { success: false, error: 'An error occurred while booking classes. Please try again.' };
        }
    }

    async createGuestUserAndBook(email, venueId, classId, dates = null) {
        try {
            // First create guest user
            const guestRes = await fetch(`${baseUrl}/api/users/create-guest`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email,
                    venueId: venueId
                })
            });

            if (!guestRes.ok) {
                const error = await guestRes.text();
                console.error('Failed to create guest account:', error);
                return { success: false, error: 'Failed to create guest account. Please try again.' };
            }

            const guestResult = await guestRes.json();

            // Use the temporary token to book the class
            const bookingEndpoint = dates && dates.length > 0
                ? `${baseUrl}/api/classes/book-bulk`
                : `${baseUrl}/api/classes/signup/${classId}`;

            const bookingBody = dates && dates.length > 0
                ? { classId: parseInt(classId), dates: dates }
                : {};

            const bookRes = await fetch(bookingEndpoint, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${guestResult.token}`,
                    'Content-Type': 'application/json'
                },
                body: dates && dates.length > 0 ? JSON.stringify(bookingBody) : undefined
            });

            if (bookRes.ok) {
                const bookResult = await bookRes.json();
                return {
                    success: true,
                    paymentUrl: bookResult.paymentUrl,
                    guestToken: guestResult.token,
                    message: 'Guest account created successfully. Please complete payment to confirm your booking.'
                };
            } else {
                const error = await bookRes.text();
                console.error('Failed to book class for guest:', error);
                return { success: false, error: 'Failed to book class for guest. Please try again.' };
            }
        } catch (error) {
            console.error('Error creating guest user and booking:', error);
            return { success: false, error: 'An error occurred while creating your booking. Please try again.' };
        }
    }
}
